<template lang="pug">
    Tabs.newsletter-subscription-topic-list
        el-card.contains-table(shadow="always")
            .error(v-if="error")
                template(v-if="error.code")
                    Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
                template(v-else)
                    Error(:message="$t('Something went wrong!')" :code="501")
            .newsletter-subscriptions-table(v-else)
                //- :row-link-config="subscriptionTopicsPaginated.link"
                paginated-items(
                    scope="ex"
                    type="nwsltr_subscription_topic"
                    :loading="loading"
                    :items="subscriptionTopicsPaginated.items"
                    :filters="filters"
                    :show-filters="showFilters"
                    :variables="subscriptionTopicsPaginated.variables"
                    :all-columns="subscriptionTopicsPaginated.allColumns"
                    :active-columns="subscriptionTopicsPaginated.activeColumns"
                    :page-info="subscriptionTopicsPaginated.pageInfo"
                    :sort="sort"
                    @pagination-size-change="handleSizeChange"
                    @pagination-current-change="handleCurrentChange"
                    @show-table-columns="handleColsShow"
                    @change-filter="handleFilterInputChange"
                    @change-sort="handleSortInputChange"
                    @click="handleClick"
                )
                    template(slot="top")
                        el-row.table-top(v-loading="loading" type="flex" justify="space-between")
                            .left
                                el-button(type="primary" size="mini" icon="el-icon-fa-plus fas" @click="addSubscriptionTopic")
                                    | {{ $t('New Newsletter Subscription Topic') }}
                            .right.hide-on-empty
                                el-button(
                                    plain
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-fa-filter fas"
                                    @click="toggleFilterVisiblity"
                                    :disabled="disable.showFilters || hasFilters"
                                )
                                    span(v-if="showFilters") {{ $t('Hide filters') }}
                                    span(v-else) {{ $t('Show filters') }}
</template>

<i18n>
{
    "de": {
        "New Newsletter Subscription Topic": "Neues Abonnement-Thema",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Newsletter Subscription Topic list could not be fetched.": "Abonnement-Thema Liste konnte nicht abgerufen werden."
    }
}
</i18n>

<script>
import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo'

import router from '@/router'
import pinia from '@/pinia';
import { useSetupStore, useNewsletterSubscriptionTopicStore } from '@/stores'

import PaginatedItems from '@/components/PaginatedItems'
import Tabs from '@/views/cms/Marketing/Partials/Tabs'
import Error from '@/components/Error'

export default {
    name: 'SubscriptionTopics',
    data() {
        return {
            // loading: true,
            error: false,
            disable: {
                showFilters: false,
            }
        }
    },
    components: {
        PaginatedItems,
        Error,
        Tabs
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true)
            if (reload) this.initialize()
        },
    },
    computed: {
        showFilters() {
            return this.hasFilters || _.get(this.subscriptionTopicsPaginated, 'showFilters') || false
        },
        hasFilters() {
            return ! _.isEmpty(this.filters)
        },
        filters() {
            let filters = _.cloneDeep(this.subscriptionTopicsPaginated.filters)
            delete filters.cms
            return filters
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        debounce() {
            return useSetupStore().debounce;
        },
        subscriptionTopicStore() {
            return useNewsletterSubscriptionTopicStore();
        },
        loading() {
            return this.subscriptionTopicStore.loading;
        },
        subscriptionTopicsPaginated() {
            return this.subscriptionTopicStore.subscriptionTopicsPaginated;
        },
        sort() {
            var variables = this.subscriptionTopicsPaginated.variables;
            var defaultSort = this.subscriptionTopicsPaginated.defaultSort || { field: 'created_at', direction: 'desc' };
            var order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            var direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;
            return { field: order, direction: direction };
        },
        setupStore() {
            return useSetupStore();
        }
    },
    methods: {
        initialize() {
            if (! this.enabledExtensions.includes('newsletter')) {
                this.subscriptionTopicStore.updateLoading(true)
                // this.$router.push({ name: 'marketing' })

                return
            }

            this.subscriptionTopicStore.updateLoading(true)
            this.refetch()
        },
        getCurrency(item) {
            return _.get(item, 'currency')
        },
        addSubscriptionTopic() {
            // TODO
            // open stepper modal

            const params = { id: 'new' }
            router.push({ name: 'newsletter-subscription-topic-main', params })
        },
        handleClick(item) {
            const params = { id: item.id }
            router.push({ name: 'newsletter-subscription-topic-main', params })
        },
        handleSizeChange(itemsPerPage) {
            this.subscriptionTopicStore.updateLoading(true)
            this.subscriptionTopicStore.defineItemsPerPage(itemsPerPage)
            this.refetch()
        },
        handleCurrentChange (currentPage) {
            this.subscriptionTopicStore.updateLoading(true)
            this.subscriptionTopicStore.defineCurrentPage(currentPage)
            this.refetch()
        },
        handleColsShow(visibleColumns) {
            this.subscriptionTopicStore.defineActiveColumns(visibleColumns)
            // apolloClient.cache.reset()
            apolloClient.clearStore()
        },
        handleFilterInputChange(key, value, debounce = true) {
            this.subscriptionTopicStore.defineFilterValue({ key, value })
            if (debounce) this.debouncedRefetch()
            else this.refetch()
        },
        handleSortInputChange(key, value) {
            this.subscriptionTopicStore.defineSorting({ key, value })
            this.refetch()
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters

            let value = false
            if (! visible) value = true

            this.disable.showFilters = true
            this.subscriptionTopicStore.defineFilterVisibility(value)
            this.saveFilterVisibility({ scope: 'ex', key: 'nwsltr_subscription_topic', value })
                .finally(() => this.disable.showFilters = false)
        },
        refetch() {

            // always add the cms id to filters
            const cmsID = this.activeCms.id
            const filter = {
                key: 'cms',
                match: cmsID,
            }
            this.subscriptionTopicStore.defineFilterValue({ key: 'cms', value: filter })

            this.subscriptionTopicStore.fetchSubscriptionTopicsPaginated()
                .then(() => this.subscriptionTopicStore.updateLoading(false))
                .catch(err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Newsletter Subscription Topic list could not be fetched.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.subscriptionTopicStore.updateLoading(false);

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                })
        },
        debouncedRefetch: _.debounce(function() { // function scope is needed here
            this.subscriptionTopicStore.updateLoading(true)
            this.refetch()
        }, useSetupStore(pinia).debounce || 300),
        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        },
    },
    mounted() {
        this.initialize()
    },
}
</script>

<style lang="sass" scoped>
.error
    padding: 20px
</style>
